<template>
  <div>
    <exibition-mode></exibition-mode>
    <exibition-frequency></exibition-frequency>
  </div>
</template>

<script>
import ExibitionMode from './exibitionmode/Main.vue';
import ExibitionFrequency from './exibitionfrequency/Main.vue';

export default {
  components: {
    ExibitionMode,
    ExibitionFrequency,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?214a586d
 **/